import { render } from "./UserActivation.vue?vue&type=template&id=3f222766&scoped=true&ts=true"
import script from "./UserActivation.vue?vue&type=script&lang=ts"
export * from "./UserActivation.vue?vue&type=script&lang=ts"

import "./UserActivation.vue?vue&type=style&index=0&id=3f222766&scoped=true&lang=css"

import exportComponent from "D:\\a\\1\\s\\mobileApp\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3f222766"]])

export default __exports__